import ReactMarkdown from "react-markdown";
import styled from "styled-components";

export const StyledReactMarkdown = styled(ReactMarkdown)`
  img {
    max-width: 100%;
    display: block;
    margin: auto;
  }
`;
